import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex text-gray-800" }
const _hoisted_3 = ["textContent"]

import { computed, ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import { PeopleService } from '@/services';
import { PersonStores } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivateUserButton',
  setup(__props) {

const profileStore = PersonStores.useUserProfileStore();

const toast = useToast();

const openActivate = ref(false);

const isActivated = computed<boolean>(() => {
  const person = profileStore.person;
  return !!person?.user?.can_login && !person?.archived_at;
});

const hasEmail = computed<boolean>(() => profileStore.general?.email);

const iconType = computed(() => (!hasEmail.value ? 'warning' : 'info'));

const iconColor = computed(() => [
  {
    color: hasEmail.value ? 'grey' : 'orange',
  },
]);

const activateMessage = computed(() =>
  hasEmail.value
    ? 'This user will be sent an email with a link which will allow them to set a password and sign in to their account.'
    : 'An email address is required to activate access. Please add a valid email address in the profile section of the user.',
);

const onCancel = () => (openActivate.value = false);

const onOpenActivate = () => (openActivate.value = true);

const onActivate = async () => {
  await PeopleService.activateAccess(Number(profileStore.person.id))
    .then((response) => doSuccess(response.data.message))
    .catch((error) => doFail(error.data.message));

  openActivate.value = false;
};

const doSuccess = (detail: string) => {
  toast.add({
    severity: 'success',
    summary: 'Success',
    detail: detail,
    life: 3000,
  });
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (!isActivated.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (openActivate.value)
          ? (_openBlock(), _createBlock(_component_ConfirmAction, {
              key: 0,
              header: "Activate Access",
              "show-footer": hasEmail.value,
              "accept-label": "Activate Access",
              onAccept: onActivate,
              onCancel: onCancel
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_Icon, {
                    name: iconType.value,
                    style: _normalizeStyle(iconColor.value)
                  }, null, 8, ["name", "style"]),
                  _createElementVNode("span", {
                    class: "w-30rem pl-3",
                    textContent: _toDisplayString(activateMessage.value)
                  }, null, 8, _hoisted_3)
                ])
              ]),
              _: 1
            }, 8, ["show-footer"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AppButton, {
          type: "primary",
          text: "Send Access Activation Email",
          "icon-left": "send",
          onClick: onOpenActivate
        })
      ]))
    : _createCommentVNode("", true)
}
}

})